import { LitElement, html, unsafeHTML, css, unsafeCSS } from '@hh/global.js'

var myHeaders = new Headers()
myHeaders.append('Content-Type', 'application/graphql')

export class AnatomyOfPallete extends LitElement {
  static properties = {
    cardsHtml: { type: String },
    filters: { type: String },
    handleActive: { type: String },
  }

  constructor() {
    super()
    this.handleActive = ''
    this.filters = ''
    this.cardsHtml = ''

    this.metaobjectIDs = this.getAttribute('data-metaobject-ids')
    this.title = this.getAttribute('data-title')
    this.api = this.getAttribute('data-storefront-api')
    this.url = this.getAttribute('data-storefront-url')

    myHeaders.append('X-Shopify-Storefront-Access-Token', `${this.api}`)
    this.getMetaobjectsData(this.metaobjectIDs)
  }

  connectedCallback() {
    super.connectedCallback()
  }

  async getImageViaGID(gid) {
    var raw = `query {
      node(id: "${gid}") {
        id
        ... on MediaImage {
          image {
            url (transform:{maxHeight: 300, maxWidth: 300})
          }
        }
      }
    }`

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    const response = await fetch(
      `https://${this.url}/api/2023-07/graphql.json`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        const {
          data: {
            node: { image: url },
          },
        } = result

        return url
      })
      .catch((error) => console.log('error', error))

    return response.url
  }

  async getMetaobjectsData(gids) {
    const ids = JSON.stringify(gids.split(','))

    var raw = `query {
      nodes(ids: ${ids}) {
        id
        ... on Metaobject {
          handle
          type
          fields {
            key
            value
          }
        }
      }
    }`

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    const response = await fetch(
      `https://${this.url}/api/2023-07/graphql.json`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        const {
          data: { nodes },
        } = result

        return nodes
      })
      .catch((error) => console.log('error', error))
    this.generateSwatches(response)
    this.generateFilter(response)
  }

  generateFilter(data) {
    const tabs = data.map((swatch, i) => {
      return swatch.fields
        .filter((field) => {
          if (field.key === 'tab') {
            return field.value
          }
        })
        .map((field) => field.value)
    })

    this.filters = Array.from(new Set(tabs.flat()))
    this.handleActive = this.handleizeName(this.filters[0])
  }

  handleizeName(name) {
    // Convert the name to lowercase
    let handleizedName = name.toLowerCase()

    // Remove special characters using a regular expression
    handleizedName = handleizedName.replace(/[^a-z0-9\s]/g, '')

    // Replace spaces with hyphens
    handleizedName = handleizedName.replace(/\s+/g, '-')

    return handleizedName
  }

  async swatchTemplate(name, image, tab) {
    const imageUrl = await this.getImageViaGID(image)
    return html`<div
      class="anatomy-pallete__swatch ${this.handleizeName(tab) ===
      this.handleActive
        ? 'is-active'
        : ''}"
      data-tab-handle="${this.handleizeName(tab)}"
      data-tab="${tab}"
      data-swatch-handle=""
      @click="${(e) => {
        this.selectTab(e, true)
      }}"
    >
      <div class="anatomy-pallete__swatch--image">
        <img srcset="${imageUrl}" src="${imageUrl}" loading="lazy" />
      </div>
      <article class="anatomy-pallete__swatch--content">
        <p class="swatch-name">${name}</p>
      </article>
    </div>`
  }

  async generateSwatches(data) {
    const _this = this
    const swatches = data.map((swatch) => {
      let swatchesData = {}
      swatch.fields.forEach((field) => {
        swatchesData[field.key] = field.value
      })
      return swatchesData
    })

    const _cardsTemplate = Promise.all(
      swatches.map(async (swatch) => {
        return await _this.swatchTemplate(
          swatch.swatch_name,
          swatch.image,
          swatch.tab
        )
      })
    )

    const cardsTemplate = await _cardsTemplate
    this.cardsHtml = cardsTemplate
  }

  changeSwatchActive() {
    this.renderRoot
      .querySelectorAll(
        `.anatomy-pallete__swatch:not([data-tab-handle="${this.handleActive}"])`
      )
      .forEach((el) => {
        el.classList.remove('is-active')
      })

    this.renderRoot
      .querySelectorAll(
        `.anatomy-pallete__swatch[data-tab-handle="${this.handleActive}"]`
      )
      .forEach((el) => {
        el.classList.add('is-active')
      })
  }

  selectTab(e, isSwatch = false) {
    if (isSwatch) {
      this.handleActive = e.target
        .closest('.anatomy-pallete__swatch')
        .getAttribute('data-tab-handle')

      this.changeSwatchActive()
      return
    }

    this.handleActive = e.target.getAttribute('data-filter')
    this.changeSwatchActive()
  }

  render() {
    return html`
      <div class="anatomy-pallete__wrapper container--xl">
        <div class="anatomy-pallete__title">
          <slot name="title"></slot>
        </div>

        <div class="anatomy-pallete__filters">
          <ul>
            ${this.filters?.map((tab, i) => {
              return html`<li
                class="anatomy-pallete__filter ${this.handleizeName(tab) ===
                  this.handleActive ||
                (this.handleActive === '' && i === 0)
                  ? 'is-active'
                  : ''}"
                data-filter="${this.handleizeName(tab)}"
                @click="${(e) => {
                  this.selectTab(e)
                }}"
              >
                ${tab}
              </li>`
            })}
          </ul>
        </div>

        <div class="anatomy-pallete__subtitle">
          ${this.filters?.map((tab, i) => {
            return html`<slot
              class="tab-content ${this.handleizeName(tab) ===
                this.handleActive ||
              (this.handleActive === '' && i === 0)
                ? 'is-active'
                : ''}"
              name="${this.handleizeName(tab)}__content"
            ></slot>`
          })}
        </div>

        <div class="anatomy-pallete__swatches">
          ${this.cardsHtml?.map((card) => {
            return card
          })}
        </div>
      </div>
    `
  }

  static styles = css`
    .anatomy-pallete__wrapper {
      max-width: 1280px;
      margin: 0 auto;
    }

    .anatomy-pallete__title {
      text-align: center;
    }

    .anatomy-pallete__filters {
      margin-bottom: 20px;
    }

    .anatomy-pallete__filters > ul {
      list-style: none;
      padding: 0;
      display: flex;
      justify-content: center;
    }

    .anatomy-pallete__filter {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding-left: 10px;
      padding-right: 10px;
      text-transform: uppercase;
      height: 42px;
      cursor: pointer;
    }

    .anatomy-pallete__filter::after {
      position: absolute;
      content: '';
      height: 2px;
      width: 100%;
      background-color: #000;
      bottom: 0;
      left: 0;
      opacity: 0.2;
    }

    .anatomy-pallete__filter.is-active::after {
      opacity: 1;
    }

    .anatomy-pallete__subtitle {
      max-width: 80%;
      margin: 0px auto 50px;
    }

    .tab-content {
      font-family: 'Favorit', Helvetica, Arial, sans-serif;
      font-size: 14px;
      font-weight: 300;
      line-height: 20px;
      letter-spacing: normal;
      text-align: center;
      display: none;
    }

    .tab-content.is-active {
      display: block;
    }

    .anatomy-pallete__swatches {
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      justify-content: center;
    }

    .anatomy-pallete__swatch {
      width: calc(100% / 5);
      cursor: pointer;
    }

    .anatomy-pallete__swatch--image > img {
      width: calc(100% - 10px);
      max-width: 180px;
      height: auto;
      border-radius: 100%;
      border: 2px solid transparent;
      padding: 5px;
    }

    .anatomy-pallete__swatch.is-active .anatomy-pallete__swatch--image > img {
      border: 2px solid #000;
    }
  `
}

customElements.define('anatomy-of-pallete', AnatomyOfPallete)
